<div
  class="container"
  [style.backgroundColor]="
    matchStatus === 'COMPLETED' && setWinner ? 'rgba(255, 128, 139, 0.1)' : null
  "
>
  @if (serverSideNumber === sideNumber && matchStatus ==='IN_PROGRESS') {
  <div class="server">
    {{ returningSide?.charAt(0) }}
  </div>
  } @if (matchStatus === 'COMPLETED' && setWinner) {
  <ion-icon class="checkmark-circle {{themeService?.isDarkMode ? 'dark' : 'light'}}" name="checkmark-circle"></ion-icon>
  {{ getStatus() }}
  }
</div>
